import { inject, Injectable, OnDestroy } from '@angular/core';
import { App } from '@df/core/app';
import { MetaState } from '@df/core/meta/meta-state';
import { injectTimeoutService } from '@df/ng/timeout.service';
import { CustomerModel } from '@df/session/api/customer.model';
import { BodyClassService } from '@df/ui/body-class.service';
import { AbstractDfModalInitiatorService } from '@df/ui/modal/abstract-df-modal-initiator.service';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ICmsModalService } from '@icms/client/assets/modal/icms-modal.service';
import { Subscription } from 'rxjs';
import { isCustomerAllowed } from '../../../../customer/groups/customer-groups';
import { ACCESS_RESTRICTIONS_POPUP_OPEN_BODY_CLASS } from './access-restrictions-modal.component';

@Injectable({
    providedIn: 'root'
})
export class AccessRestrictionsModalInitiatorService extends AbstractDfModalInitiatorService implements OnDestroy {
    private unsubscribeOnRouteChange = new Subscription();
    private previousMetaState: MetaState | undefined;
    private bodyClassService = inject(BodyClassService);
    private readonly timeoutService = injectTimeoutService();

    constructor(
        protected cmsModalService: ICmsModalService,
        app: App,
        protected customerModel: CustomerModel
    ) {
        super(cmsModalService, app);
    }

    ngOnDestroy(): void {
        this.unsubscribeOnRouteChange.unsubscribe();
    }

    listen(cb: () => void, modal: NDfModal.IConfig): Promise<void> {
        return new Promise(resolve => {
            this.unsubscribeOnRouteChange.add(
                this.app.meta.subscribe(() => {
                    this.checkAndOpenModal(cb, modal);
                    this.previousMetaState = this.app.meta.state;
                })
            );

            if (this.app.meta.state !== this.previousMetaState) {
                this.checkAndOpenModal(cb, modal);
            }

            resolve();
        });
    }

    private checkAndOpenModal(cb: () => void, modal: NDfModal.IConfig): void {
        const modalData = this.app.meta.model?.data?.typeData;
        const enableAccessRestriction = modalData?.enableAccessRestriction;
        const visibility = modalData?.visibility || [];

        this.timeoutService.setTimeout(() => {
            if (enableAccessRestriction && !isCustomerAllowed(visibility, this.customerModel.data.group_id)) {
                this.cmsModalService.loadDependencies(modal).then(() => {
                    cb();
                    this.bodyClassService.add(ACCESS_RESTRICTIONS_POPUP_OPEN_BODY_CLASS, this);
                });
            }
        }, 1000);
    }
}
